import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { LoginForm } from '../components/Auth/LoginForm';

export function Login() {
  return (
    <Layout>
      <div className="min-h-[calc(100vh-64px)] flex">
        {/* Left panel — branding (hidden on mobile) */}
        <div className="hidden lg:flex lg:w-1/2 bg-gray-50 relative overflow-hidden flex-col justify-center px-16">
          <div className="absolute inset-0 dot-grid opacity-40" />
          <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-brand-100/30 rounded-full blur-[120px]" />
          <div className="relative z-10">
            <p className="text-brand-600 font-mono text-sm tracking-widest uppercase mb-4">
              Welcome Back
            </p>
            <h2 className="text-4xl font-bold text-gray-900 tracking-tight mb-4">
              US Equity Trading<br />Infrastructure
            </h2>
            <p className="text-gray-500 text-lg mb-12 max-w-md">
              Access your dashboard, manage orders, and monitor your trading infrastructure.
            </p>
            <div className="flex gap-8">
              <div>
                <p className="font-mono text-2xl font-bold text-brand-600">&lt;1ms</p>
                <p className="text-gray-500 text-xs mt-1">Processing</p>
              </div>
              <div>
                <p className="font-mono text-2xl font-bold text-brand-600">99.9%</p>
                <p className="text-gray-500 text-xs mt-1">Uptime</p>
              </div>
              <div>
                <p className="font-mono text-2xl font-bold text-brand-600">24/5</p>
                <p className="text-gray-500 text-xs mt-1">Trading</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right panel — login form */}
        <div className="flex-1 bg-white flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
          <div className="max-w-md w-full space-y-8">
            <div>
              <h2 className="text-center text-3xl font-bold text-gray-900 tracking-tight">
                Sign in to your account
              </h2>
              <p className="mt-2 text-center text-sm text-gray-500">
                Or{' '}
                <Link
                  to="/signup"
                  className="font-medium text-brand-600 hover:text-brand-500 transition-colors"
                >
                  create a new account
                </Link>
              </p>
            </div>

            <div className="bg-white border border-gray-200 py-8 px-6 rounded-xl shadow-sm">
              <LoginForm />
            </div>

            <div className="text-center text-sm">
              <Link
                to="/"
                className="font-medium text-gray-500 hover:text-gray-700 transition-colors"
              >
                &larr; Back to home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
